module.exports = __webpack_public_path__ + "img/kir.db7e40f6.svg";